import "./VideoContainer.css";

import { useState } from 'react';
import Video from "./Video";


export default function VideoContainer() {
  const [activeIndex, setActiveIndex] = useState(0);

  const slideCount = 5;

  function changeSlide(index) {
    if (index >= slideCount) {
      index = 0;
    } else if (index === -1) {
      index = slideCount - 1;
    }

    setActiveIndex(index);
  }

  const baseSlideClass = "mySlides fade";

  return (
    <div className="video-container">
      <div className="slideshow-container">
        <div className={activeIndex === 0 ? baseSlideClass + " active" : baseSlideClass}>
          <Video title="Trailer" videoUrl="5Dk0PBPiv10" />
        </div>
        <div className={activeIndex === 1 ? baseSlideClass + " active" : baseSlideClass}>
          <Video title="Gameplay" videoUrl="g6YCgGJZ5V4" />   
        </div>
        <div className={activeIndex === 2 ? baseSlideClass + " active" : baseSlideClass}>
          <Video title="Trailer" videoUrl="tQLcVbRlaKk" />
        </div>
        <div className={activeIndex === 3 ? baseSlideClass + " active" : baseSlideClass}>
          <Video title="WeaponUpgrades" videoUrl="hKlrUEzFcCg" />
        </div>
        <div className={activeIndex === 4 ? baseSlideClass + " active" : baseSlideClass}>
          <Video title="Action" videoUrl="rl8lVp4907c" />
        </div>
        <span className="prev" onClick={() => changeSlide(activeIndex - 1)}>&#10094;</span>
        <span className="next" onClick={() => changeSlide(activeIndex + 1)}>&#10095;</span>
      </div>
    </div>
  );
}
